import type {
  BurndownReport,
  ForecastResponse,
  ReportSummary,
  StreamsResponse,
  TestersResponse,
  TrendResponse,
} from '@testflow/shared';
import { request } from './api.js';

const base = (p: string) => `/v1/projects/${p}`;

export const reportsApi = {
  summary(projectId: string, testPlanId: string, nodeId?: string): Promise<ReportSummary> {
    const q = new URLSearchParams({ test_plan_id: testPlanId });
    if (nodeId) q.set('node_id', nodeId);
    return request<ReportSummary>(`${base(projectId)}/reports/summary?${q.toString()}`);
  },
  burndown(projectId: string, testPlanId: string): Promise<BurndownReport> {
    return request<BurndownReport>(
      `${base(projectId)}/reports/burndown?test_plan_id=${testPlanId}`,
    );
  },
  forecast(projectId: string, testPlanId: string): Promise<ForecastResponse> {
    return request<ForecastResponse>(
      `${base(projectId)}/reports/forecast?test_plan_id=${testPlanId}`,
    );
  },
  // #97: Blocker/Hoch je Kalenderwoche aus den täglichen Snapshots (Task 6).
  trend(projectId: string, testPlanId: string): Promise<TrendResponse> {
    return request<TrendResponse>(`${base(projectId)}/reports/trend?test_plan_id=${testPlanId}`);
  },
  // #98.2: eine Zeile je Struktur-Knoten (Teilprojekt/Stream) für die Stream-Tabelle (Task 10).
  streams(projectId: string, testPlanId: string): Promise<StreamsResponse> {
    return request<StreamsResponse>(
      `${base(projectId)}/reports/streams?test_plan_id=${testPlanId}`,
    );
  },
  // #98.3: Fortschritt je Tester für die Tester-Tabelle (Task 10).
  testers(projectId: string, testPlanId: string): Promise<TestersResponse> {
    return request<TestersResponse>(
      `${base(projectId)}/reports/testers?test_plan_id=${testPlanId}`,
    );
  },
};
